import { request } from "../utils/Request"
const BaseUrl = process.env.REACT_APP_STLLR_API_URL

export const fetchDeals = async ({ page = 1, limit = 20, type, date_from, date_to } = {}) => {
    return request({
        url: `${BaseUrl}v1/deals`,
        params: { page, limit, type, date_from, date_to },
    }, true)
}

export const fetchDeal = async (id) => {
    return request({
        url: `${BaseUrl}v1/deals/${id}`,
    }, true)
}

export const createDeal = async (data) => {
    return request({
        url: `${BaseUrl}v1/deals`,
        method: "POST",
        data,
    }, true)
}

export const updateDeal = async (id, data) => {
    return request({
        url: `${BaseUrl}v1/deals/${id}`,
        method: "PUT",
        data,
    }, true)
}

export const deleteDeal = async (id) => {
    return request({
        url: `${BaseUrl}v1/deals/${id}`,
        method: "DELETE",
    }, true)
}

export const linkCampaign = async (dealId, campaignId) => {
    return request({
        url: `${BaseUrl}v1/deals/${dealId}/campaign/${campaignId}`,
        method: "POST",
    }, true)
}

export const unlinkCampaign = async (dealId, campaignId) => {
    return request({
        url: `${BaseUrl}v1/deals/${dealId}/campaign/${campaignId}`,
        method: "DELETE",
    }, true)
}

export const createPayment = async (data) => {
    return request({
        url: `${BaseUrl}v1/payments`,
        method: "POST",
        data,
    }, true)
}

export const deletePayment = async (id) => {
    return request({
        url: `${BaseUrl}v1/payments/${id}`,
        method: "DELETE",
    }, true)
}

export const fetchPaymentMethods = async () => {
    return request({
        url: `${BaseUrl}v1/payment-methods`,
    }, true)
}

export const uploadFile = async (file) => {
    const formData = new FormData()
    formData.append('attachment', file)
    return request({
        url: `${BaseUrl}v1/files`,
        method: "POST",
        data: formData,
        headers: { 'Content-Type': 'multipart/form-data' },
    }, true)
}

export const fetchRevenue = async ({ page = 1, limit = 20, type = 'all', date_from, date_to } = {}) => {
    return request({
        url: `${BaseUrl}v1/admin/revenue`,
        params: { page, limit, type, date_from, date_to },
    }, true)
}
